import { FormControl } from '@mui/material'
import { C1Checkbox } from 'components/core/checkbox/C1Checkbox'
import React from 'react'
import { Control, Controller } from 'react-hook-form'

type C1FormCheckboxProps = {
    control: Control<any> // eslint-disable-line @typescript-eslint/no-explicit-any
    name: string
    error?: boolean
    label: React.ReactNode
}
export const C1FormCheckbox = ({ control, name, error, label, ...props }: C1FormCheckboxProps): React.ReactElement => {
    return (
        <FormControl error={error}>
            <Controller
                name={name}
                control={control}
                render={({ field }): React.ReactElement => (
                    <C1Checkbox
                        id={name}
                        label={label}
                        checked={!!field.value}
                        onChange={field.onChange}
                        inputProps={{
                            'aria-invalid': error ? 'true' : 'false',
                        }}
                        {...props}
                    />
                )}
            />
        </FormControl>
    )
}
